import { Link } from 'react-router-dom'
import netzence from '../../images/Frame 2147228713.png'
import image1 from '../../images/datawithSS.png'
import image2 from '../../images/traffic.png'
import image3 from '../../images/sus1.png'
import Header from '../shared/Header'
import Footer from '../shared/Footer'
import sportlight from '../../images/spotlight.png'
function BlogPost1() {

     const blogs = [
    {
      id: 1,
      badge: "Sustainability",
      badgeColor: "#006633",
      title: "How Netzence is Redefining Urban Mobility in Nigeria",
      description: "Exploring how smart technology, real-time data, and carbon tracking are creating affordable and sustainable transport solutions for Nigerian cities.",
      source: "25/03/2026",
      image: image1,
      readMoreLink: "#"
    },
    {
      id: 2,
      badge: "Climate Action",
      badgeColor: "#006633",
      title: "Kano Climate Initiative: Pioneering Clean Mobility in Northern Nigeria",
      description: "How Kano State is leading the charge in adopting CNG-powered public transport and reducing carbon emissions across the region.",
      source: "06/01/2026",
      image: image2,
      readMoreLink: "#"
    },
    {
      id: 3,
      badge: "Tech Innovation",
      badgeColor: "#00AED9",
      title: "The Role of AI in Building Low-Carbon Transport Ecosystems",
      description: "From predictive routing to driver behaviour analytics, discover how artificial intelligence is transforming Nigeria's mobility landscape.",
      source: "30/12/2025",
      image: image3,
      readMoreLink: "#"
    }
  ];
  return (
<>

<Header/> 
<Link to="/blogs">
<div className='ml-72 text-[14px] flex pt-20'>
    Return to blog
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 18L15.5 12L9.5 6" stroke="#898989" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


</div>
</Link>
<div className='ml-72 text-[24px] font-bold'>Introducing Low-cost mobility for Nigeria’s transport system - Netzence</div>
<div className='ml-72 flex gap-5 mt-10 '>
    <img loading='lazy'src={netzence} alt="netzence" className='w-[48px]'></img>


    <div>
        <div className='text-[16px] mb-3'>
            Netzence 
        </div>
        <div className='flex items-center gap-3 '>
            December 28, 2025 <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="3" cy="3" r="3" fill="#898989"/>
</svg>
7 mins read
        </div>
    </div>


</div>
<div className='ml-72 mr-72 mt-20'>
    <img loading='lazy' src={sportlight} alt="spotlight" className='object-fill w-[1200px]'></img>
</div>

 <div className="flex flex-col items-start gap-4 w-full max-w-[1152px] h-auto mt-20 ml-72" >
      {/* Paragraph 1 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        Nigeria's mobility ecosystem is undergoing a profound shift. Rising fuel prices, worsening congestion, and growing urban populations have pushed transportation costs to levels that are increasingly unsustainable for millions of commuters. By April 2025, average city bus fares had climbed to about ₦999, while intercity trips reached as high as ₦7,902. For many Nigerians, daily commuting now costs between ₦1,000 and ₦4,000. With petrol selling above ₦1,000 per litre and diesel hovering between ₦1,400 and ₦1,500, traditional transport models are under severe strain.
      </p>

      {/* Paragraph 2 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        Yet this pressure also presents an opportunity. High costs are forcing a long-overdue rethink of how Nigerians move—opening the door to mobility systems that are cheaper to operate, cleaner for cities, and smarter for users. Rather than signalling the collapse of urban transport, today's challenges are accelerating Nigeria toward a necessary mobility revolution.
      </p>

      {/* Paragraph 3 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        This is the space Netzence Sustainability Limited is positioning itself to redefine. Its approach goes beyond incremental fixes, offering a ground-up reimagining of urban movement. By combining real-time intelligence, predictive routing, carbon tracking, driver-behaviour analytics, and operational optimisation, Netzence is building a model that delivers affordability by eliminating waste—not by compromising quality.
      </p>

      {/* Paragraph 4 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        The vision is ambitious but practical: affordable eco-rides operating in coordinated networks; verified driver-safety systems embedded into every trip; emissions-linked reward programmes that translate responsible driving into lower fares; and live traffic heat maps that enable dynamic routing across cities. More than cheap tickets, this approach tackles air pollution, chronic congestion, lost productivity, and public-health risks—creating a transport system that is both inclusive and sustainable.
      </p>

      {/* Paragraph 5 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        According to Netzence's Chief Executive Officer, Dr. Sadiq Sani, the company aims to ensure that every Nigerian has access to low-cost transport alternatives by April 2026, supported by its CloseCarbon technology and an upcoming clean-mobility application.
      </p>

      {/* Paragraph 6 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        Ads by The weaknesses of Nigeria's current transport system clearly indicate where reform is most urgent. Gridlock inflates fuel consumption and emissions. Inefficient routing, ageing fleets, and high levels of empty mileage drive up costs for operators and passengers alike. Monthly commuting expenses range from ₦8,000 to ₦96,000, depending on transport combinations, while private car owners often spend well over ₦100,000 monthly on fuel and maintenance. These are not just challenges; they are precise signals of where efficiency, real-time intelligence, and cleaner technologies can deliver dramatic cost reductions and restore predictability to urban movement.
      </p>

      {/* Paragraph 7 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        Early clean-mobility pilots in Nigeria already show measurable results. Where smart operational tools are deployed, transport costs have fallen by 30 to 60 per cent without sacrificing reliability. Ride-pooling alone can halve fares—from about ₦2,400 for solo trips to as low as ₦1,200—while reducing empty mileage that erodes operator profits. In several cities, on-demand shared rides have improved travel predictability and strengthened access to healthcare, education, and employment centres.
      </p>

      {/* Paragraph 8 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        Fuel transition is another critical lever. Nigeria's growing adoption of Compressed Natural Gas (CNG) demonstrates how cleaner energy can also be cheaper. CNG costs nearly half the price of petrol, enabling cities such as Kaduna to operate buses at fares as low as ₦300 per trip, with minibuses charging around ₦800. This shift has delivered estimated savings of ₦1.39 billion to 1.4 million users. Nationwide, converting 1,440 vehicles to CNG is projected to unlock up to ₦500 billion in fuel savings, cut harmful emissions by 57 per cent, and diversify the urban mobility energy mix. These gains are underpinned by ₦791 million invested in more than 65 CNG retail sites, collectively servicing close to 18,000 vehicles daily.
      </p>

      {/* Paragraph 9 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        Digital systems further amplify these benefits. Real-time fuel-use monitoring highlights inefficient driving habits, while live route optimisation steers vehicles away from congestion, reducing fuel burn and travel time. Demand analytics align vehicles with peak travel periods, minimising idle time and unnecessary cruising. Safety layers—driver verification, panic alerts, and emergency response pathways—address longstanding security concerns in Nigeria's informal transport sector. Cashless payment and digital wallet systems eliminate revenue leakage, reduce operational risk, and improve fare transparency.
      </p>

      {/* Paragraph 10 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        The combined impact is significant. Fares can fall by 40 to 50 per cent, reliability improves, and commuters gain safer alternatives to high-risk transport options. Households using CNG-based ride-sharing save up to ₦12,000 monthly—effectively increasing disposable income by about 31 per cent.
      </p>

      {/* Paragraph 11 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        At a national level, Nigeria's mobility transition aligns with global sustainability trends. With billions of dollars already flowing into ride-hailing and clean-transport ecosystems, and projections suggesting millions of electric vehicles by mid-century, the environmental upside is substantial. Cleaner mobility could prevent tens of millions of tonnes of carbon emissions annually while dramatically improving urban air quality—particularly in megacities like Lagos.
      </p>

      {/* Paragraph 12 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        As Nigeria continues to urbanise, smart, low-emission mobility is no longer a luxury or an environmental ideal. It is an economic imperative—one that boosts productivity, strengthens resilience, and improves quality of life. The future of transport in Nigeria will not be defined by rising costs alone, but by how boldly innovation is deployed to turn today's pressures into lasting opportunity.
      </p>
    </div>

   <div className="items-start gap-10 w-full max-w-[1200px] h-[43px] ml-72">
        <h2 
          className="text-[#0D924F] font-bold text-4xl leading-[43px] w-[225px] h-[43px]"
          style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
        >
          Related Blogs
        </h2>
      </div>

     <div className=" items-start gap-10 w-full max-w-[1201px] h-auto mt-20 ">
      {/* Header */}
   
      {/* Cards Container */}
      <div className="flex flex-row items-stretch gap-8 w-full flex-wrap ml-72 lg:flex-nowrap mb-20">
        {blogs.map((blog) => (
          <div 
            key={blog.id}
            className="flex flex-col items-center pb-6 gap-4 w-[379px] h-[544px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-2xl shrink-0"
          >
            {/* Image */}
            <div className="w-[378px] h-[282px] rounded-t-2xl overflow-hidden">
              <img 
                src={blog.image} 
                alt={blog.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Article Content */}
            <div className="flex flex-col items-start gap-4 w-[352px] h-[222px]">
              {/* Badge */}
              <div 
                className="flex flex-row justify-center items-center px-1.5 py-0.5 gap-2 h-[25px] rounded"
                style={{ backgroundColor: blog.badgeColor }}
              >
                <span 
                  className="text-white font-medium text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.badge}
                </span>
              </div>

              {/* Text Container */}
              <div className="flex flex-col items-start gap-3 w-full">
                {/* Title */}
                <h3 
                  className="text-[#3B3B3B] font-semibold text-[20px] leading-[24px] tracking-[-0.02em] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv01' on, 'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.title}
                </h3>
                
                {/* Description */}
                <p 
                  className="text-[#898989] font-normal text-[14px] leading-[20px] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.description}
                </p>
              </div>

              {/* Footer */}
              <div className="flex flex-row justify-between items-center w-full">
                <span 
                  className="text-[#3B3B3B] font-normal text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.source}
                </span>
                
                <a 
                  href={blog.readMoreLink}
                  className="flex flex-row justify-center items-center gap-2 transition-all duration-150 hover:opacity-80 group"
                >
                  <span 
                    className="text-[#006633] font-medium text-[14px] leading-[20px]"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Read More
                  </span>
                  <div className="relative w-2.5 h-4 flex items-center justify-center">
                    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 1L6.5 6L1.5 11" stroke="#006633" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
<Footer/>
</>
  )
}

export default BlogPost1